<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <!-- <j-title-header :options="title"/> -->

    <div class="container-top-admin">
      <div class="d-flex m__b--20 m__l--20">
        <i
          class="fa fa-arrow-left fa-lg cursor-pointer p__t--3"
          @click="$router.push(`/admin-kelas/kelas/${$route.params.idTahun}`)"/>
        <div class="top-label-admin"> TAHUN AJARAN {{ dataTahunAjaran ? dataTahunAjaran.tahunajaran : '' }} </div>
        <i class="fa fa-angle-right fa-lg cursor-pointer p__t--3 m__l--5"/>
        <div class="label-tahun-ajaran"> {{ dataKelas ? dataKelas.name : '' }} </div>
      </div>

      <div class="d-flex">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'kelas'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="selectTab('kelas')">
          DATA KELAS
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'siswa'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="selectTab('siswa')">
          SISWA
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'walikelas'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="selectTab('walikelas')">
          WALI KELAS
        </div>
      </div>
    </div>

    <div
      v-if="tabSelected === 'kelas'"
      class="m__t--45">
      <b-row>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.data_master_kelas.kode_kelas.$error}">
            <label> KODE </label>
            <j-input
              v-model="$v.data_master_kelas.kode_kelas.$model"
              :disabled="true"
              placeholder="Kode"/>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.data_master_kelas.nama_kelas.$error}">
            <label> NAMA KELAS </label>
            <j-input
              v-model="$v.data_master_kelas.nama_kelas.$model"
              :disabled="true"
              placeholder="Nama"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.data_master_kelas.kode_prodi.$error}">
            <label> PRODI </label>
            <j-single-select
              v-model="$v.data_master_kelas.kode_prodi.$model"
              :disabled="true"
              :options="list_prodi"
              placeholder="Pilih Prodi"
              label="name"/>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.data_master_kelas.status.$error}">
            <label> STATUS </label>
            <j-single-select
              v-model="$v.data_master_kelas.status.$model"
              :options="list_status"
              :disabled="true"
              placeholder="Pilih Status"
              label="name"/>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div
      v-if="tabSelected === 'siswa'"
      class="m__t--45">
      <v-server-table
        v-if="show_table"
        v-show="load_first"
        ref="tableServer"
        :columns="columns"
        :options="options"
        class="jTable"
        @loading="loading"
        @loaded="loaded"
        @row-click="clickDetail">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              v-if="!readOnly"
              class="btn grey btn-import-form m__r--5"
              @click="createData">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <j-import-file-oos
              v-if="openImport && !readOnly"
              :href-sample="require('@/assets/file/FORMAT_IMPORT_BAGI_KELAS.zip')"
              class="import-style"
              @import-data="importData"/>
            <div class="cc-btn">
              <b-button
                v-if="is_error"
                class="btn outline red"
                @click="$refs.editSiswa.show()">
                <i class="fa fa-close"/>
                Open Error Data
              </b-button>
              <!-- <b-button
                v-else-if="data_import && !is_error"
                class="btn green outline"
                @click="uploadData">
                Import Data
              </b-button> -->
            </div>
          </b-form>
        </div>
      </v-server-table>
      <jLoadingTable v-if="show_table && !load_first"/>

      <b-modal
        ref="modalKelas"
        class="mod-form modal-kelas"
        centered
        no-close-on-backdrop
        no-close-on-esc>
        <div class="title-bold ql-align-center">{{ data_master.id ? 'Rubah' : 'Tambah' }} Siswa</div>

        <b-form-group :class="{'error-input' : $v.data_master.nis.$error}">
          <label>Siswa</label>
          <j-single-select
            v-model="$v.data_master.nis.$model"
            :load-options="loadOptionsSiswa"
            :is-async="true"
            :cache-option="false"
            :default-options="false"
            :disabled="readOnly"
            placeholder="Ketik minimal 3 karakter untuk mencari siswa"
            value-format="object"
            label="name"/>
            <!-- <j-single-select
            v-model="$v.data_master.nis.$model"
            :options="list_siswa"
            placeholder="Pilih Siswa"
            value-format="object"
            label="name"/> -->
        </b-form-group>

        <b-row>
          <b-col md="4">
            <b-button
              v-if="data_master.id && !readOnly"
              class="btn red"
              @click="deleteData">
              Delete
            </b-button>
          </b-col>
          <b-col md="8">
            <div class="float-to-right">
              <b-button
                class="btn gray"
                @click="closeData">
                Cancel
              </b-button>
              <b-button
                v-if="!readOnly"
                class="btn blue m__l--5"
                @click="saveData">
                {{ data_master.id ? 'Update' : 'Save' }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-modal>

      <j-progress-screen
        ref="ImportFile"
        :data-kirim="data_import"
        :url-api="url"
        :headers="headers"
        @finish="reloadPage"/>

      <b-modal
        ref="editSiswa"
        class="mod-form"
        centered>
        <h3 class="float-to-center c--red">
          Error Data
        </h3>
        <v-client-table
          v-if="error_data[0]"
          :data="error_data"
          :columns="columns"
          :options="options"
          class="jTable">

          <div
            slot="ERROR"
            slot-scope="props">
            <div
              v-for="(err, index) in props.row.ERROR"
              :key="index">
              {{ err }}
            </div>
          </div>

        </v-client-table>
        <download-excel
          :data="error_data"
          class="float-to-right m__t--30"
          name="data-error.xls">
          <b-button class="btn green">
            Export Error
          </b-button>
        </download-excel>
      </b-modal>
    </div>

    <div
      v-if="tabSelected === 'walikelas'"
      class="m__t--45">
      <v-server-table
        v-if="show_table_wali"
        v-show="load_first_wali"
        ref="tableServerWali"
        :columns="columns_wali"
        :options="options_wali"
        class="jTable"
        @loading="loadingWali"
        @loaded="loadedWali"
        @row-click="clickDetailWali">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              v-if="!readOnly"
              class="btn grey btn-import-form m__r--5"
              @click="createDataWali">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
          </b-form>
        </div>
      </v-server-table>
      <jLoadingTable v-if="show_table_wali && !load_first_wali"/>

      <b-modal
        ref="modalWaliKelas"
        class="mod-form modal-kelas"
        centered
        no-close-on-backdrop
        no-close-on-esc>
        <div class="title-bold ql-align-center">{{ data_master_wali.id ? 'Rubah' : 'Tambah' }} Walikelas</div>

        <b-form-group :class="{'error-input' : $v.data_master_wali.pegawai.$error}">
          <label>Pegawai</label>
          <j-single-select
            v-model="$v.data_master_wali.pegawai.$model"
            :options="list_pegawai"
            :placeholder="'Pilih Pegawai'"
            :disabled="readOnly"
            value-format="object"
            label="name"/>
        </b-form-group>

        <b-row>
          <b-col md="4">
            <b-button
              v-if="data_master_wali.id && !readOnly"
              class="btn red"
              @click="deleteDataWali">
              Delete
            </b-button>
          </b-col>
          <b-col md="8">
            <div class="float-to-right">
              <b-button
                class="btn gray"
                @click="closeDataWali">
                Cancel
              </b-button>
              <b-button
                v-if="!readOnly"
                class="btn blue m__l--5"
                @click="saveDataWali">
                {{ data_master_wali.id ? 'Update' : 'Save' }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jProgressScreen from '@/components/progress-screen/jProgressScreen';
import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import Vue from 'vue';

export default {
  components: {
    jLoadingTable,
    jProgressScreen,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Bagi Kelas',
      },
      tabSelected: 'kelas',
      nis: null,
      tahun_ajaran: null,
      kelas: null,

      data_master_kelas: {
        nama_kelas: '',
        kode_kelas: '',
        kode_prodi: null,
        status: null,
      },
      data_master: {
        nis: null,
        tahunajaran: null,
        kode_kelas: null,
      },
      data_master_wali: {
        pegawai: null,
        tahunajaran: null,
        kode_kelas: null,
      },

      show_table: false,
      show_table_wali: false,

      list_prodi: [],
      list_siswa: [],
      list_kelas: [],
      list_pegawai: [],
      list_tahun_ajaran: [],
      list_status: [
        {
          id: 'aktif',
          name: 'Aktif',
        },
        {
          id: 'tidak aktif',
          name: 'Tidak Aktif',
        },
      ],
      dataTahunAjaran: null,
      dataKelas: null,

      load_first: false,
      data_table: [],
      columns: ['id', 'nama_kelas', 'kode_kelas', 'nis', 'nama_siswa', 'tahunajaran'],
      options: {
        headings: {
          id: 'ID',
          nama_kelas: 'NAMA KELAS',
          kode_kelas: 'KODE KELAS',
          nis: 'NIS',
          nama_siswa: 'NAMA SISWA',
          tahunajaran: 'TAHUN AJARAN',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              // limit: data.limit,
              // page: data.page,
              // nis: data.nis,
              tahunajaran: data.tahunajaran,
              kode_kelas: data.kode_kelas,
            },
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.listBagiKelas(data.pagination);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      load_first_wali: false,
      data_table_wali: [],
      columns_wali: ['id', 'kode_pegawai', 'nama_pegawai', 'nip'],
      options_wali: {
        headings: {
          id: 'ID',
          kode_pegawai: 'KODE PEGAWAI',
          nama_pegawai: 'NAMA PEGAWAI',
          nip: 'NIP',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              // limit: data.limit,
              // page: data.page,
              // nis: data.nis,
              tahunajaran: data.tahunajaran,
              kode_kelas: data.kode_kelas,
            },
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.listWaliKelas(data.pagination);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      openImport: true,
      data_import: null,
      list_error: [],
      error_data: [],
      is_error: false,
    };
  },
  computed: {
    url() {
      const getEnv = 'siswa/bagi-kelas/create';
      return getEnv;
    },
    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },
  },
  watch: {
  },
  created() {
    this.listTahunAjaran();
    // this.listKelas();
    // this.listSiswa();
    this.getListProdi();
    this.listPegawai();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['createBagiKelas', 'updateBagiKelas', 'deleteBagiKelas', 'getListTahunAjaran', 'getListKelas', 'getListKelasAll', 'getListSiswa',
      'createWaliKelas', 'updateWaliKelas', 'deleteWaliKelas']),
    ...mapActions('jStoreKurikulum', ['listProdi', 'getListPegawai']),

    selectTab(val) {
      this.show_table = false;
      this.show_table_wali = false;
      this.tabSelected = val;

      setTimeout(() => {
        if (val === 'siswa') { this.show_table = true; }
        if (val === 'walikelas') { this.show_table_wali = true; }
      }, 500);
    },

    loadOptionsSiswa({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              query: searchQuery,
              query_type: 'nama_siswa',
              tahunajaran_new: this.dataTahunAjaran.tahunajaran,
              kode_kelas_new: this.dataKelas.kode,
              page: 1,
              limit: 1000,
            },
          };
          this.$store.dispatch('jStoreKesiswaan/getListSiswaAsyncNisName', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    listPegawai() {
      this.getListPegawai().then((res) => {
        this.list_pegawai = res.data.data;
      });
    },

    listSiswa() {
      const params = {
        pagination: {
          query: '',
          query_type: 'nama_siswa',
          tahunajaran_new: this.dataTahunAjaran.tahunajaran,
          kode_kelas_new: this.dataKelas.kode,
          page: 1,
          limit: 5000,
        },
      };
      this.getListSiswa(params).then((res) => {
        // const dataSiswa = res.data.data.slice(0, 10);
        const dataSiswa = res.data.data;
        this.list_siswa = dataSiswa.map(el => ({
          id: el.id,
          nis: el.nis,
          name: `${el.nis} - ${el.nama_siswa}`,
        }));
      });
    },

    getDataKelas() {
      const params = {
        pagination: {
          query: this.tahun_ajaran.tahunajaran,
          query_type: 'tahunajaran',
        },
      };
      this.getListKelas(params).then((res) => {
        this.list_kelas = res.data.data;
      });
    },

    listTahunAjaran() {
      const paramTahunAjaran = {
        pagination: {
          query: '',
          query_type: '',
        },
      };
      this.getListTahunAjaran(paramTahunAjaran).then((res) => {
        this.list_tahun_ajaran = res.data.data;
        this.dataTahunAjaran = res.data.data.find(f => f.id === this.$route.params.idTahun);
        this.listKelas();
      });
    },

    getListProdi() {
      this.listProdi().then((res) => {
        this.list_prodi = res.data.data.map(el => ({
          id: el.kode_prodi,
          name: el.nama_prodi,
        }));
      });
    },

    listKelas() {
      const params = {
        pagination: {
          query: '',
          query_type: 'kode_kelas',
        },
      };
      this.getListKelasAll(params).then((res) => {
        this.list_kelas = res.data.data;
        this.dataKelas = res.data.data.find(f => f.id === this.$route.params.idKelas);
        this.data_master_kelas = {
          nama_kelas: this.dataKelas.name,
          kode_kelas: this.dataKelas.kode,
          kode_prodi: this.dataKelas.kode_prodi,
          status: this.dataKelas.status,
        };
        this.listSiswa();
      });
    },

    loading(val) {
      const a = val;
      // a.pagination.nis = this.nis ? this.nis.nis : '';
      // a.pagination.tahunajaran = this.tahun_ajaran ? this.tahun_ajaran.tahunajaran : '';
      // a.pagination.kode_kelas = this.kelas ? this.kelas.kode : '';
      a.pagination.tahunajaran = this.dataTahunAjaran.tahunajaran;
      a.pagination.kode_kelas = this.dataKelas.kode;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
    },

    createData() {
      this.$refs.modalKelas.show();
    },

    closeData() {
      this.$refs.modalKelas.hide();
      this.data_master = {
        nis: null,
        tahunajaran: null,
        kode_kelas: null,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = {
          nis: this.data_master.nis.nis,
          tahunajaran: this.dataTahunAjaran.tahunajaran,
          kode_kelas: this.dataKelas.kode,
        };
        if (this.data_master.id) { params.id = this.data_master.id; }
        const action = this.data_master.id ? 'updateBagiKelas' : 'createBagiKelas';
        this[action](params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeData();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteBagiKelas(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeData();
              }, 1500);
            }
          });
        }
      });
    },

    clickDetail({ row }) {
      const dataSiswa = this.list_siswa.find(f => f.nis === row.nis);
      this.$refs.modalKelas.show();
      this.data_master = {
        id: row.id,
        nis: dataSiswa || null,
        tahunajaran: row.tahunajaran,
        kode_kelas: row.kode_kelas,
      };
    },

    importData(val) {
      const keys = Object.keys(val[0]);
      if (keys[0] !== 'NIS' || keys[1] !== 'TAHUN_AJARAN' || keys[2] !== 'KODE_KELAS') {
        this.toggleProblem('Please use header format correctly');
      }
      this.is_error = false;
      this.list_error = [];
      this.error_data = val;
      const fileData = val;
      const genData = [];
      fileData.forEach((e, index) => {
        const ccData = this.convertData(e, index);
        if (ccData !== false) {
          genData.push(ccData);
        }
      });
      this.data_import = genData;

      setTimeout(() => {
        if (this.data_import && !this.is_error) {
          this.$refs.ImportFile.toggleIsVisible();
        }
      }, 1000);
    },

    convertData(val, indexData) {
      this.list_error[indexData] = [];
      this.error_data[indexData].ERROR = [];
      const packing = {
        nis: val.NIS,
        tahunajaran: val.TAHUN_AJARAN,
        kode_kelas: val.KODE_KELAS,
      };
      if (!val.NIS) {
        this.is_error = true;
        this.list_error[indexData].push('NIS tidak boleh kosong');
        this.error_data[indexData].ERROR.push('NIS tidak boleh kosong');
      }
      if (!val.TAHUN_AJARAN) {
        this.is_error = true;
        this.list_error[indexData].push('Tahun Ajaran tidak boleh kosong');
        this.error_data[indexData].ERROR.push('Tahun Ajaran tidak boleh kosong');
      }
      if (!val.KODE_KELAS) {
        this.is_error = true;
        this.list_error[indexData].push('Kode Kelas tidak boleh kosong');
        this.error_data[indexData].ERROR.push('Kode Kelas tidak boleh kosong');
      }
      return packing;
    },

    uploadData() {
      this.$refs.ImportFile.toggleIsVisible();
    },

    reloadPage() {
      this.$refs.tableServer.getData();
      this.openImport = false;
      this.data_import = null;
      this.list_error = [];
      this.error_data = [];
      this.is_error = false;
      setTimeout(() => {
        this.openImport = true;
      }, 500);
    },

    loadingWali(val) {
      const a = val;
      // a.pagination.nis = this.nis ? this.nis.nis : '';
      // a.pagination.tahunajaran = this.tahun_ajaran ? this.tahun_ajaran.tahunajaran : '';
      // a.pagination.kode_kelas = this.kelas ? this.kelas.kode : '';
      a.pagination.tahunajaran = this.dataTahunAjaran.tahunajaran;
      a.pagination.kode_kelas = this.dataKelas.kode;
      if (this.load_first_wali) {
        this.showLoading();
      }
    },

    loadedWali(data) {
      this.data_table_wali = data.data.data;
      if (this.load_first_wali) {
        this.hideLoading();
      } else {
        this.load_first_wali = !this.load_first_wali;
      }
    },

    refreshTableWali() {
      this.$refs.tableServerWali.getData();
    },

    filterWali(val) {
      this.$refs.tableServerWali.setFilter(val);
    },

    createDataWali() {
      this.$refs.modalWaliKelas.show();
    },

    closeDataWali() {
      this.$refs.modalWaliKelas.hide();
      this.data_master_wali = {
        pegawai: null,
        tahunajaran: null,
        kode_kelas: null,
      };
    },

    saveDataWali() {
      this.$v.data_master_wali.$touch();
      if (!this.$v.data_master_wali.$error) {
        const params = {
          kode_pegawai: this.data_master_wali.pegawai.kode_pegawai,
          tahunajaran: this.dataTahunAjaran.tahunajaran,
          kode_kelas: this.dataKelas.kode,
        };
        if (this.data_master_wali.id) { params.id = this.data_master_wali.id; }
        const action = this.data_master_wali.id ? 'updateWaliKelas' : 'createWaliKelas';
        this[action](params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServerWali.getData();
              this.closeDataWali();
            }, 1500);
          }
        });
      }
    },

    deleteDataWali() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master_wali.id,
          };
          this.deleteWaliKelas(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServerWali.getData();
                this.closeDataWali();
              }, 1500);
            }
          });
        }
      });
    },

    clickDetailWali({ row }) {
      const pegawaiSelected = this.list_pegawai.find(f => f.kode_pegawai === row.kode_pegawai);
      this.$refs.modalWaliKelas.show();
      this.data_master_wali = {
        id: row.id,
        pegawai: pegawaiSelected || null,
        tahunajaran: row.tahunajaran,
        kode_kelas: row.kode_kelas,
      };
    },
  },
  validations() {
    return {
      nis: { required },
      tahun_ajaran: { required },
      kelas: { required },

      data_master_kelas: {
        nama_kelas: { required },
        kode_kelas: { required },
        kode_prodi: { required },
        status: { required },
      },
      data_master: {
        nis: { required },
        tahunajaran: {},
        kode_kelas: {},
      },
      data_master_wali: {
        pegawai: { required },
        tahunajaran: {},
        kode_kelas: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/admin-kelas/jBagiKelas.vue